import type {Poll, PollQuestion, Subpoll} from 'src/api'

import type {PollType} from './Form.types'

/**
 * Находит в списке вопросов вопрос, на который не дан ответ. Если все ответы заполнены, возвращает последний вопрос
 * @param subPoll Subpoll с данными для вопросов который приходит с бека
 * @param values уже данные ответы в формате оъекта ключ - id вопроса, значение массив из id ответов.
 * id вопросов и ответов - строки
 * @returns текущий вопрос на который не дан ответ. Если все ответы заполнены, возвращает последний вопрос
 */
function getCurrentQuestion(subPoll: Subpoll, values: PollType) {
  let question = subPoll.questions.find(item => item.id === subPoll.root_question_id)
  while (question && question.id in values) {
    const selectAnswerId = values[question.id][0]
    const selectAnswer = question.answers.find(answer => selectAnswerId === answer.id)
    if (selectAnswer?.next_question_id === undefined) {
      return question
    }
    question = subPoll.questions.find(item => item.id === selectAnswer.next_question_id)
  }
  return question
}

/**
 * Находит в списке вопросов вопрос, на который не дан ответ для каждого subpolls в poll.
 * Если все ответы в subpoll заполнены, в массиве для этого subpoll будет находится последний вопрос
 * @param poll данныt для вопросов который приходит с бека
 * @param values уже данные ответы в формате оъекта ключ - id вопроса, значение массив из id ответов.
 * id вопросов и ответов - строки
 * @returns массив из текущийх вопросов каждого subpoll на которыйе не даны ответы.
 */
export function getSubPollQuestions(poll: Poll, values: PollType): PollQuestion[] {
  return poll.subpolls
    .map(subPoll => getCurrentQuestion(subPoll, values))
    .filter((item): item is PollQuestion => item !== undefined)
}
